import { Component, Input } from '@angular/core';
import { cn } from '../../../../../utils/utils';

export interface ICardTips {
  title: string;
  description: string;
}

@Component({
  selector: 'app-segment-information-tips-card',
  standalone: true,
  imports: [],
  templateUrl: './segment-information-tips-card.component.html',
  styleUrl: './segment-information-tips-card.component.css',
})
export class SegmentInformationTipsCardComponent {
  merge = cn

  @Input() header: string = 'Preview';
  @Input() cardClass: string = '';
  @Input() headerClass: string = '';
  @Input() tipsClass: string = '';
  @Input() tipClass: string = '';
  @Input() divide:boolean = false;
  @Input({ required: true }) tips: ICardTips[] = [];
}
